import { trigger } from 'swr';
import { HprCacheKeys } from '../cacheKeys';
import { useHprService } from '../../context/HprServiceContext';


export const useCompanyCache = () => {
    const service = useHprService();
    const token = service.getToken();

    const revalidateList = () => {
        trigger(HprCacheKeys.CompanyList(token));
    };

 

    return {
        revalidateList,
    };
};
